(function () {
  var cfg = window.ipBlockConfig || {};

  if (!cfg.enabled) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var blocked = (cfg.blockedIpsRaw || cfg.blockedIps || '')
    .split('\n')
    .map(function (ip) { return ip.trim(); })
    .filter(Boolean);

  if (!blocked.length) return;

  function showDenied() {
    document.documentElement.innerHTML =
      '<head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Access Denied</title></head>' +
      '<body style="margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:Arial,sans-serif;background:#f5f5f5;">' +
        '<div style="max-width:480px;padding:32px;background:#fff;border-radius:8px;text-align:center;">' +
          '<h1 style="margin:0 0 12px;">Access Denied</h1>' +
          '<p style="margin:0;color:#444;">' + (cfg.message || 'Access denied.') + '</p>' +
        '</div>' +
      '</body>';
  }

  fetch('https://api.ipify.org?format=json')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.ip && blocked.indexOf(data.ip) !== -1) {
        showDenied();
      }
    })
    .catch(function (err) {
      console.error('IP block check failed', err);
    });
})();